import React from "react";
import { createStyles, makeStyles, Grid } from "@material-ui/core";
import { CustomTheme } from "../../../../types/customTheme";
import ProductList from "./ProductList"; // Import the new recursive component

const useStyles = makeStyles((theme: CustomTheme) =>
  createStyles({
    dividerStyle: {
      margin: "0px 0px 20px 0px",
      backgroundColor: theme.palette.custom.grey.main,
      height: "2px",
      borderRadius: "10px",
      width: "100%",
    },
  }),
);

export interface MenuInfoPageProps {
  wrapperProduct: any[]; // Consider a more specific type for 'any'
  removedLinkedIdList: any; // The original code seems to use this inconsistently. It's likely `removedLinkedIdLists` is the correct prop name.
  handleUpdateIdList: any;
  index: any;
  isColorChange: any;
  revertExpand: any;
  handleSelectProduct:  any;
  category: any;
  handleClickLinkedId: any;
  removedLinkedIdLists: any; // Renamed to plural for clarity
  handleNavigate: (item: any, level: number, parentData: any) => any;
  handleClearStrip: (item: any) => void;
  selectedWrapperIdList: any;
  setSelectedWrapperIdList: (ids: any) => void;
  isOwner: boolean;
  editableRewardDetails: any;
}

const ProductWrapper: React.FC<MenuInfoPageProps> = (props) => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      <ProductList products={props.wrapperProduct} {...props} />
    </Grid>
  );
};

export default ProductWrapper;
